/**
 * Turns a stored clinic/location logo value into the URL the report letterhead
 * renders. Bare keys are prefixed with the assets bucket; legacy path-style S3
 * URLs are rewritten to the virtual-hosted form.
 */
export const resolveLetterheadLogoUrl = (logo?: string | null): string | undefined => {
  if (!logo) return undefined;

  if (!logo.startsWith('http')) {
    return `${import.meta.env.VITE_S3_ASSETS_URL}/${logo}`;
  }

  return logo.includes('s3.amazonaws.com/chiroup-assets/')
    ? logo.replace('s3.amazonaws.com/chiroup-assets', 'chiroup-assets.s3.amazonaws.com')
    : logo;
};
